export default __webpack_public_path__ + "static/media/HackPlus.56913645.svg";